import { Injectable } from '@angular/core';

@Injectable()
export class DeviceInteractionService {

    constructor() { }

    get id() {
        return JSON.parse(window.sessionStorage.getItem('device-interaction-id'));
    }

    set id(value: string) {
        window.sessionStorage.setItem('device-interaction-id', JSON.stringify(value));
    }

}
